module.exports = __webpack_public_path__ + "img/pg5-article2-bg.c9ac650e.png";